module.exports = __webpack_public_path__ + "img/wrapbg1.9c2ea6f8.png";